var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box-container",on:{"click":_vm.onConnectClick}},[_c('video',{ref:"video",staticClass:"black",attrs:{"autoplay":""}}),(_vm.connected && !_vm.publishers.length)?_c('div',{staticClass:"white-noise"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }